import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { getMedicineNameStage } from '../../api/chatApi/chatApi';

interface TooltipData {
  testingstage_id: number;
  name: string;
  job_hint: string;
  stage_hint: string;
  stage_hint_name: string;
  stage_hint_blue: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginBottom: theme.spacing(1),
      padding: theme.spacing(3),
      borderRadius: '5px',
      boxShadow: '0px 0px 16px rgba(0,0,0,0.1)',
      backgroundColor: '#fff',
    },
    title: {
      fontSize: 16,
      fontWeight: 'bold',
      marginBottom: theme.spacing(1),
      textAlign: 'center'
    },
    list: {
      paddingLeft: theme.spacing(2),
      listStyle: 'square outside',
      color: theme.palette.text.secondary,
    },
    warning: {
      fontWeight: 'bold',
      textAlign: 'center',
      marginTop: theme.spacing(3),
      padding: theme.spacing(1),
      borderRadius: '5px',
      boxShadow: '0 0 4px 3px rgba(0,0,0,0.1)',
      backgroundColor: '#CBE8FF',
    },
  })
);

interface ChatTooltipProps {
  task_id: number,
  testingStageId: number
}

export default function ChatTooltip({ task_id, testingStageId }: ChatTooltipProps) {
  const classes = useStyles();
  const [tooltipText, setTootipText] = useState<TooltipData | null>(null)

  useEffect(() => {
    getMedicineNameStages()
  }, [])

  async function getMedicineNameStages() {
    try {
      const result = await getMedicineNameStage({ task_id: task_id })

      if (result.data.MedicineNameStage && result.data.MedicineNameStage.length > 0) {
        const stageHintElement = result.data.MedicineNameStage.find(el => el.testingstage_id === Number(testingStageId))
        setTootipText(stageHintElement)
      }

    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <div className={classes.container}>
        <div
          className={classes.title}
          dangerouslySetInnerHTML={{
            __html: tooltipText ? tooltipText.stage_hint_name : testingStageId === 1 ? 'Пообщайтесь с пациентом в чате и соберите анамнез' : 'Для этого этапа нет подсказок'
          }}
        />
        {testingStageId === 1 ? <div>Примеры вопросов:</div> : null}
        {tooltipText ? (
          <div dangerouslySetInnerHTML={{ __html: tooltipText.stage_hint }} />
        ) : testingStageId === 1 ? (
          <ul className={classes.list}>
            <li>Жалобы ("На что жалуетесь?")</li>
            <li>Наследственный анамнез ("Какой Вы по счету ребенок?")</li>
            <li>
              Трудовой анамнез ("Кем Вы работаете?")
            </li>
            <li>Эпидемиологический анамнез ("Вы недавно выезжали за границу?") </li>
            <li>
              Перенесенные в прошлом заболевания ("Вы в детстве переболели ветрянкой или краснухой?")
            </li>
            <li>
              Перенесенные операции ("Подвергались ли Вы хирургическому вмешательству?")
            </li>
            <li>Гинекологический анамнез ("Когда у Вас была последняя менструация?")</li>
            <li>Бытовые условия ("У Вас в доме есть горячая вода?") </li>
            <li>Характер питания ("Сколько раз в день Вы кушаете?") </li>
            <li>Вредные привычки ("Вы курите?") </li>
            <li>
              Прием гормональных препаратов ("Вы принимаете гормональные препараты по назначению врача?")
            </li>
            <li>Гемотрансфузионный анамнез ("Вам переливали кровь?") </li>
          </ul>
        ) : (
          null
        )}
      </div>
      {tooltipText ? (
        <div className={classes.warning}>{tooltipText.stage_hint_blue}</div>
      ) : testingStageId === 1 ? (
        <div className={classes.warning}>
          Собранные по методике сбора анамнеза вопросы будут оцениваться модулем статистики
        </div>
      ) : (
        null
      )}
    </>
  )
}




